import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMarketablePreference, updateMarketablePreference } from '../data/actions';

function useMarketingPreference() {
  const { marketablePreference: { isMarketable, isLoading } } = useSelector(state => state.register);

  const dispatch = useDispatch();

  // Load preference on mount
  useEffect(() => {
    dispatch(getMarketablePreference());
  }, [dispatch]);

  // Handle change
  const handleChange = async () => {
    if (isLoading) { return; }
    dispatch(updateMarketablePreference(!isMarketable));
  };

  return { isMarketable, handleChange };
}

export default useMarketingPreference;
